import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-solutions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './solutions.html',
  styleUrl: './solutions.scss',
})
export class Solutions {
  ts = inject(TranslationService);
  t = this.ts.t;

  cards = computed(() => [
    { icon: 'shield',    title: this.t().sol_card1_title, desc: this.t().sol_card1_desc, color: '#0066cc',
      features: [this.t().sol_feat1_1, this.t().sol_feat1_2, this.t().sol_feat1_3] },
    { icon: 'hard-hat',  title: this.t().sol_card2_title, desc: this.t().sol_card2_desc, color: '#f59e0b',
      features: [this.t().sol_feat2_1, this.t().sol_feat2_2, this.t().sol_feat2_3] },
    { icon: 'leaf',      title: this.t().sol_card3_title, desc: this.t().sol_card3_desc, color: '#22c55e',
      features: [this.t().sol_feat3_1, this.t().sol_feat3_2, this.t().sol_feat3_3] },
    { icon: 'chart',     title: this.t().sol_card4_title, desc: this.t().sol_card4_desc, color: '#a855f7',
      features: [this.t().sol_feat4_1, this.t().sol_feat4_2, this.t().sol_feat4_3] },
  ]);
}
